import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs';
import { Visibility } from '../interfaces/project';
import { PortfolioProjectService } from '../portfolio-project.service';
import { UserService } from '../services/user-service/user.service';

export const hiddenProjectGuard: CanActivateFn = (route) => {
  const projectService = inject(PortfolioProjectService);
  const userService = inject(UserService);
  const router = inject(Router);

  const id = route.paramMap.get('id');
  if (!id) {
    return of(router.createUrlTree(['/portfolio']));
  }

  return projectService.getProjectById(id).pipe(
    take(1),
    switchMap((project) => {
      if (!project) {
        return of(router.createUrlTree(['/portfolio']));
      }
      const v = project.visibility ?? Visibility.public;
      if (v === Visibility.personal) {
        return userService.isAdmin$.pipe(
          take(1),
          map((admin) => (admin ? true : router.createUrlTree(['/portfolio'])))
        );
      }
      if (v !== Visibility.hidden) {
        return of(true);
      }
      return userService.isAuthenticated$.pipe(
        take(1),
        map((signedIn) =>
          signedIn
            ? true
            : router.createUrlTree(['/login'], { queryParams: { returnUrl: router.url } })
        )
      );
    }),
    catchError(() =>
      of(
        router.createUrlTree(['/login'], {
          queryParams: { returnUrl: router.url }
        })
      )
    )
  );
};
